import { render, staticRenderFns } from "./observations.vue?vue&type=template&id=2e34eec4&v-if=loaded&"
import script from "./observations.vue?vue&type=script&lang=js&"
export * from "./observations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports